// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3lCzq","paramInput":"JobSimulator_paramInput__3GIxC","input":"JobSimulator_input__3vsyZ"};